import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { securedFetch } from "../../auth/authService";
import { DEVICE_AUTHORIZATION_API, USER_API } from "../../vars";
import { getSortAndFilterQueryString } from "../../view/urlService";
import { ACTION_DEVICE_AUTHORIZATIONS_CHANGED } from "./DeviceAuthorizationPageReducer";

export const AUTHORIZATION_VALUES = ["ALLOWED", "BLOCKED"];

export function listAuthorizationsPageable(pageNumber, pageSize, deviceId) {
    let queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    if (deviceId) {
        queryString += `&f_deviceId=${deviceId}`;
    }

    return securedFetch(`${DEVICE_AUTHORIZATION_API}/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_DEVICE_AUTHORIZATIONS_CHANGED)({
                authorizations: data.page,
                totalAuthorizationRecords: data.records
            }));
            return { devices: data.page, totalPages: data.total, pageNumber, totalRecords: data.records };
        });
}

export function listAuthorizationsByDevice(deviceId) {
    return securedFetch(`${DEVICE_AUTHORIZATION_API}/device/${deviceId}`)
        .then(response => response.json())
        .then(data => {
            const authorizations = Array.isArray(data) ? data : [];
            store.dispatch(createAction(ACTION_DEVICE_AUTHORIZATIONS_CHANGED)({
                authorizations,
                totalAuthorizationRecords: authorizations.length
            }));
            return authorizations;
        });
}

export function saveAuthorization(authorization) {
    return securedFetch(DEVICE_AUTHORIZATION_API, authorization, "POST")
        .then(response => response.json());
}

export function updateAuthorization(authorization) {
    return securedFetch(`${DEVICE_AUTHORIZATION_API}/${authorization.id}`, authorization, "POST")
        .then(response => response.json());
}

export async function deleteAuthorization(id) {
    return securedFetch(`${DEVICE_AUTHORIZATION_API}/${id}`, null, "DELETE")
        .then(response => response.ok);
}

export function getUsers() {
    return securedFetch(USER_API)
        .then(response => response.json())
        .then(data => Array.isArray(data) ? data : []);
}
